// Admin user drawer constants shared with the admin users page.
export const DIRECTORY_SYNC_LABEL = 'Directory Sync';

export const DIRECTORY_SYNC_MANAGED_MESSAGE = 'Managed by your identity provider';
